import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { usePermissions } from "@/hooks/usePermissions";

type ModuleKey =
  | 'dashboard'
  | 'projects'
  | 'contracts'
  | 'portfolios'
  | 'strategic'
  | 'calendar'
  | 'tasks';

interface Props {
  module: ModuleKey;
  children: ReactNode;
  fallbackPath?: string;
}

/**
 * Bloqueia acesso a uma rota se o usuário PADRAO/VISUALIZACAO tiver o módulo desativado.
 * ADMIN e SUPERVISOR sempre passam. Defaults do banco são TRUE — nada quebra.
 */
export const CapabilityGate = ({ module, children, fallbackPath = "/projects" }: Props) => {
  const { canViewModule, isLoadingPermissions, getUserRole } = usePermissions();

  if (isLoadingPermissions) {
    return (
      <div className="flex items-center justify-center min-h-[40vh] w-full">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  const role = getUserRole();
  if (role === 'ADMIN' || role === 'SUPERVISOR') return <>{children}</>;

  if (!canViewModule(module)) {
    // Se ele nem pode ver "projects", vamos redirecionar para settings pessoal
    const safe = module === 'projects' ? '/settings' : fallbackPath;
    return <Navigate to={safe} replace />;
  }

  return <>{children}</>;
};
